import { Box } from "@mui/material";
import paper from "../../assets/paper.png";

export function PaperJobContent() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      mt={{ xs: 10, md: 24 }}
    >
      <Box
        component="img"
        src={paper}
        alt="Paper mockup"
        sx={{
          borderRadius: 0,
          height: { xs: "220px", sm: "280px", md: "350px" },
          objectFit: "contain",
          userSelect: "none",
          pointerEvents: "none",
        }}
        draggable={false}
      />
    </Box>
  );
}
